import { BANNER_TYPES, DSBanner } from '@elliemae/ds-banner';
import moment from 'moment';
import { HISTORICAL_PRICING_TEXT } from '../HeaderMenu/utils/constants';
import { useIsHistoricalPricing } from '../../../../common/utils/customHooks/useIsHistoricalPricing';

export const PricingNotificationHeader = () => {
  const { isOpen, setOpen, showMessage, effectiveDate } =
    useIsHistoricalPricing();

  const getEffectiveDate = () =>
    moment.tz(effectiveDate, 'America/New_York').format('MM-DD-yyyy hh:mm A');

  return (
    <DSBanner
      body={`Effective Date ${getEffectiveDate()} EST`}
      isOpen={showMessage && isOpen}
      label={HISTORICAL_PRICING_TEXT}
      onClose={() => setOpen(false)}
      type={BANNER_TYPES.WARNING}
      data-testid="PricingNotificationHeader-all-components"
    />
  );
};
